import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'

import { RootState } from './store'

type Severity = 'error' | 'warning' | 'info' | 'success'

export interface SnackbarMessage {
  id: string
  message: string
  severity: Severity
}

interface SnackbarState {
  snackbars: SnackbarMessage[]
}

const initialState: SnackbarState = {
  snackbars: [],
}

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    addSnackbar: (
      state,
      action: PayloadAction<{
        message: string
        severity: Severity
      }>,
    ) => {
      state.snackbars = [
        ...state.snackbars,
        NewSnackBar(action.payload.message, action.payload.severity),
      ]
    },
    removeSnackbar: (
      state,
      action: PayloadAction<{
        snackbarId: string
      }>,
    ) => {
      state.snackbars = state.snackbars.filter(
        (snackbar) => snackbar.id !== action.payload.snackbarId,
      )
    },
  },
})

function NewSnackBar(message: string, severity: Severity): SnackbarMessage {
  return {
    id: uuidv4(),
    message: message,
    severity: severity,
  }
}

export const getSnackbars = (state: RootState) => state.snackbar.snackbars
export const { addSnackbar, removeSnackbar } = snackbarSlice.actions
export default snackbarSlice.reducer
